import { TextCodes } from '@api/types/translation/TextCodes';
import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { breakpoints } from '@themes/theme.helpers';
import { t } from '@translations';
import { useContext } from 'react';
import { ProductDetailsContext } from './ProductDetailsContext';

// STYLES
//--------

const ProductTitleWrapper = styled(Box)`
  ${breakpoints.up('xs')} {
    display: flex;
    justify-content: space-between;
    gap: 24px;
  }
`;

const BoxTitle = styled(Box)`
  margin-bottom: 16px;

  h1 {
    margin: 0;
    font-size: 32px;
  }
  h3 {
    font-weight: 600;
    font-size: 16px;
    line-height: 160%;
    letter-spacing: 0.01em;
    color: #1c1c1c;
    margin: 0 0 0 2px;
  }
`;
// COMPONENTS
//------------

export const ProductTitle = () => {
  const { product = {} } = useContext(ProductDetailsContext);
  const { itemERPDescription, productNo = '' } = product;
  const productTitle = t(TextCodes.Product.Details.ProductNumber, { productNo });

  return (
    <ProductTitleWrapper>
      <BoxTitle>
        {itemERPDescription && <h1>{itemERPDescription}</h1>}
        {productTitle && <h3>{productTitle}</h3>}
      </BoxTitle>
    </ProductTitleWrapper>
  );
};
